import { connect } from "react-redux";
import { useHistory } from "react-router";
import Card from "../../components/card";
import { Warning } from "../../components/button";
import { Col, ContainerEmpty, EmptyMsgCarts, EmptyMsgDesCarts } from "./style";
import CartImg from "../../assets/images/icon/cart.png";

const Empty = (props) => {
  const history = useHistory();

  const { theme } = props;

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <Col className="col-12">
      <ContainerEmpty>
        <Card className="text-center pt-5 pb-3">
          <img src={CartImg} alt="" />
          <EmptyMsgCarts className="mt-5 f-16" theme={theme}>
            سبد خرید شما در حال حاضر خالی است.
          </EmptyMsgCarts>
          <EmptyMsgDesCarts className="mt-3 f-12" theme={theme}>
            می‌توانید برای مشاهده غذا بیشتر به صفحات زیر بروید
          </EmptyMsgDesCarts>
          <Warning
            title="سفارش غذا"
            className="d-block mt-4 mx-5"
            onClick={() => onChangeRoute("/")}
            seq
          />
        </Card>
      </ContainerEmpty>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Empty);
